import AnalogsPage from './AnalogsPage';
import analogsPageReducer from './reducer';

export { analogsPageReducer };
export default AnalogsPage;
